// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banner Block Styles */
.banner-block {
    background: linear-gradient(135deg, var(--admin-color) 0%, var(--button-hover-color) 100%);
    color: white;
    text-align: center;
    padding: 60px 20px;
    position: relative;
    border-radius: var(--border-radius);
}

.banner-block h2 {
    font-size: 2.5rem;
    margin-bottom: 15px;
    font-weight: 700;
}

.banner-block p {
    font-size: 1.2rem;
    margin-bottom: 25px;
    opacity: 0.9;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.banner-btn {
    background: white;
    color: var(--admin-color);
    padding: 12px 30px;
    border: none;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.banner-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.banner-image {
    margin-top: 20px;
    text-align: center;
}

.banner-image img {
    max-width: 100%;
    height: auto;
    border-radius: var(--border-radius);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* Edit Form Styles */
.edit-form {
    display: grid;
    gap: 15px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.form-group label {
    font-weight: 600;
    color: var(--card-title-color);
    font-size: 14px;
}

.form-control {
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s ease;
    background: var(--bs-body-bg-color);
    color: var(--text-color);
}

.form-control:focus {
    outline: none;
    border-color: var(--admin-color);
    box-shadow: 0 0 0 2px rgba(0,84,96,0.25);
}

/* Responsive Design */
@media (max-width: 768px) {
    .banner-block h2 {
        font-size: 2rem;
    }
    
    .banner-block p {
        font-size: 1rem;
    }
    
    .banner-block {
        padding: 40px 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/BannerBlock/BannerBlock.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,0FAA0F;IAC1F,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* Banner Block Styles */\n.banner-block {\n    background: linear-gradient(135deg, var(--admin-color) 0%, var(--button-hover-color) 100%);\n    color: white;\n    text-align: center;\n    padding: 60px 20px;\n    position: relative;\n    border-radius: var(--border-radius);\n}\n\n.banner-block h2 {\n    font-size: 2.5rem;\n    margin-bottom: 15px;\n    font-weight: 700;\n}\n\n.banner-block p {\n    font-size: 1.2rem;\n    margin-bottom: 25px;\n    opacity: 0.9;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.banner-btn {\n    background: white;\n    color: var(--admin-color);\n    padding: 12px 30px;\n    border: none;\n    border-radius: 25px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: inline-block;\n}\n\n.banner-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(0,0,0,0.2);\n}\n\n.banner-image {\n    margin-top: 20px;\n    text-align: center;\n}\n\n.banner-image img {\n    max-width: 100%;\n    height: auto;\n    border-radius: var(--border-radius);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n/* Edit Form Styles */\n.edit-form {\n    display: grid;\n    gap: 15px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.form-group label {\n    font-weight: 600;\n    color: var(--card-title-color);\n    font-size: 14px;\n}\n\n.form-control {\n    padding: 8px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    font-size: 14px;\n    transition: border-color 0.2s ease;\n    background: var(--bs-body-bg-color);\n    color: var(--text-color);\n}\n\n.form-control:focus {\n    outline: none;\n    border-color: var(--admin-color);\n    box-shadow: 0 0 0 2px rgba(0,84,96,0.25);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .banner-block h2 {\n        font-size: 2rem;\n    }\n    \n    .banner-block p {\n        font-size: 1rem;\n    }\n    \n    .banner-block {\n        padding: 40px 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
